@if (inline) {
  <div class="flatpickr-inline-container" #inlineContainer></div>
} @else {
  <div class="flatpickr-date-picker" [class.disabled]="disabled">
    @if (label) {
      <label class="flatpickr-label">{{ label }} @if(required) {<span class="required">*</span>}</label>
    }
    <div class="datepicker-input-container">
      <input
        class="flatpickr-input"
        type="text"
        [disabled]="disabled"
        [(ngModel)]="value"
        [placeholder]="computedPlaceholder"
        #dateInput />
        @if(noCalendar) {
          <svg class="calendar-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9987 1.3335C4.3227 1.3335 1.33203 4.32416 1.33203 8.00016C1.33203 11.6762 4.3227 14.6668 7.9987 14.6668C11.6747 14.6668 14.6654 11.6762 14.6654 8.00016C14.6654 4.32416 11.6747 1.3335 7.9987 1.3335ZM7.9987 13.3335C5.05803 13.3335 2.66536 10.9408 2.66536 8.00016C2.66536 5.0595 5.05803 2.66683 7.9987 2.66683C10.9394 2.66683 13.332 5.0595 13.332 8.00016C13.332 10.9408 10.9394 13.3335 7.9987 13.3335Z" fill="#9FA1A4"/>
            <path d="M8.66536 4.6665H7.33203V8.27584L9.52736 10.4712L10.47 9.5285L8.66536 7.72384V4.6665Z" fill="#9FA1A4"/>
        </svg>
        } @else {
          <svg class="calendar-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66406 7.33325H5.9974V8.66659H4.66406V7.33325ZM4.66406 9.99992H5.9974V11.3333H4.66406V9.99992ZM7.33073 7.33325H8.66406V8.66659H7.33073V7.33325ZM7.33073 9.99992H8.66406V11.3333H7.33073V9.99992ZM9.9974 7.33325H11.3307V8.66659H9.9974V7.33325ZM9.9974 9.99992H11.3307V11.3333H9.9974V9.99992Z" fill="#9FA1A4"/>
            <path d="M3.33333 14.6666H12.6667C13.402 14.6666 14 14.0686 14 13.3333V5.33325V3.99992C14 3.26459 13.402 2.66659 12.6667 2.66659H11.3333V1.33325H10V2.66659H6V1.33325H4.66667V2.66659H3.33333C2.598 2.66659 2 3.26459 2 3.99992V5.33325V13.3333C2 14.0686 2.598 14.6666 3.33333 14.6666ZM12.6667 5.33325L12.6673 13.3333H3.33333V5.33325H12.6667Z" fill="#9FA1A4"/>
          </svg>
        }
    </div>
  </div>
}